import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/agreements";

const headers = (apiAccessToken) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${apiAccessToken}`,
});

/**
 * The hardware products this customer may order (feature #301). The API decides visibility from
 * the caller's own membership and the agreement's assortment; the billing group narrows it.
 *
 * @param {string} agreementPublicId
 * @param {string|null} billingGroupPublicId - Optional; must belong to the agreement
 * @param {string} apiAccessToken
 * @returns {Promise<Array>} Products without any Diflex-internal fields
 */
export async function getHardwareAssortment(agreementPublicId, billingGroupPublicId, apiAccessToken) {
  const response = await axios.get(
    `${baseUrl}/HardwareProducts/assortment/by-agreement/${encodeURIComponent(agreementPublicId)}`,
    {
      params: billingGroupPublicId ? { billingGroupPublicId } : {},
      headers: headers(apiAccessToken),
    }
  );
  return response.data;
}

/**
 * The customer's client computers from Device inventory for the "existing computer" picker
 * (PBI #303). Servers and virtual machines are filtered out server-side. Returns an empty list
 * for customers without Intune, in which case the form falls back to a typed serial number.
 *
 * @param {string} tenantPublicId
 * @param {string} apiAccessToken
 * @returns {Promise<Array>}
 */
export async function getScoDevicesByTenant(tenantPublicId, apiAccessToken) {
  const response = await axios.get(
    `${baseUrl}/ManagedDevices/sco-by-tenant/${encodeURIComponent(tenantPublicId)}`,
    { headers: headers(apiAccessToken) }
  );
  return response.data;
}
